import { render, staticRenderFns } from "./TermsAndPolicies.vue?vue&type=template&id=f0c6f9f0&scoped=true&"
import script from "./TermsAndPolicies.vue?vue&type=script&lang=js&"
export * from "./TermsAndPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c6f9f0",
  null
  
)

export default component.exports